<template>
  <div class="bg-white shadow-sm border border-slate-200 overflow-hidden">
    <div class="px-6 pt-2 pb-0.5">
      <div class="flex items-baseline gap-2 flex-wrap">
        <h2 class="text-base font-bold text-[#0d4169] text-left">
          {{ resolvedCompanyName }}
        </h2>
        <span class="text-sm font-bold text-slate-600">Withholding · Received</span>
      </div>
    </div>

    <form @submit.prevent="saveEntry">
      <div class="px-6 pb-2 pt-1.5">
        <div class="flex flex-wrap items-end gap-x-6 gap-y-2">
          <div class="flex items-center gap-3 min-w-[220px]">
            <label class="text-[0.78rem] font-semibold text-[#1e293b] shrink-0">Select Date:</label>
            <input
              v-model="calendarDate"
              type="date"
              class="flex-1 min-w-[9rem] px-2 py-1 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer"
              @change="onCalendarChange"
            >
          </div>

          <!-- <div class="flex items-center gap-2">
            <button
              type="button"
              class="px-2.5 py-1.5 bg-slate-100 text-slate-700 text-[0.78rem] font-bold rounded-md transition-all flex items-center gap-1.5 whitespace-nowrap hover:bg-slate-200"
              @click="handleImport"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1m-4-8l-4-4m0 0L8 8m4-4v12" />
              </svg>
              Import (XSL)
            </button>

            <button
              type="button"
              class="px-2.5 py-1.5 bg-blue-50 text-blue-700 text-[0.78rem] font-bold rounded-md hover:bg-blue-100 transition-all flex items-center gap-1.5 border border-blue-100 whitespace-nowrap"
              @click="downloadSampleUiOnly"
            >
              <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16v1a2 2 0 002 2h12a2 2 0 002-2v-1m-4-4l-4 4m0 0l-4-4m4 4V4" />
              </svg>
              Sample Form
            </button>
          </div> -->
        </div>
      </div>

      <div class="px-6 pt-1.5 pb-4">
        <div class="w-full overflow-auto custom-scrollbar wh-table-scroll-wrap pb-2">
          <table class="wh-received-table wh-received-entry wh-received-entry-dt consumption-table-shell w-full min-w-max bg-white rounded-lg border border-slate-200">
            <!-- <caption class="caption-wh-entry caption-top text-left pb-1 text-[0.75rem] font-semibold text-[#1e293b]">
              New entry
            </caption> -->
            <thead>
              <tr>
                <th class="col-wh-date text-center bg-[#f1f5f9]">Invoice date</th>
                <th class="col-wh-expand bg-[#f1f5f9]">Company name</th>
                <th class="col-wh-text col-wh-text-field">Invoice No</th>
                <th class="col-wh-text col-wh-text-field">TIN Number</th>
                <th class="col-wh-expand col-wh-reason">Reason</th>
                <th class="num col-wh-num-50">Received<br>amount</th>
                <th class="num col-wh-num-50">Withhold 3%</th>
                <th class="num col-wh-num-50">Withhold 30%</th>
                <!-- <th class="text-center num col-wh-num-50 bg-slate-50 font-semibold text-[#0d4169]">Total Sales</th> -->
                <th class="col-wh-text col-wh-text-field">FS Number</th>
                <th class="col-wh-image text-center bg-[#f1f5f9]">Image</th>
              </tr>
            </thead>
            <tbody>
              <tr class="hover:bg-slate-50 transition-colors border-b group">
                <td class="col-wh-date cell-readonly text-center bg-[#f8fafc] group-hover:bg-slate-50">{{ displayInvoiceDate }}</td>
                <td class="col-wh-expand bg-white group-hover:bg-slate-50">
                  <input v-model.trim="draft.companyName" type="text" class="wh-text-cell" autocomplete="off">
                </td>
                <td class="col-wh-text col-wh-text-field">
                  <input v-model.trim="draft.invoiceNo" type="text" class="wh-text-cell" autocomplete="off">
                </td>
                <td class="col-wh-text col-wh-text-field">
                  <input v-model.trim="draft.tinNo" type="text" class="wh-text-cell" autocomplete="off">
                </td>
                <td class="col-wh-expand col-wh-reason">
                  <input v-model.trim="draft.reason" type="text" class="wh-text-cell" autocomplete="off">
                </td>
                <td class="num col-wh-num-50">
                  <input v-model.number="draft.receivedAmount" type="number" step="0.01" min="0" class="income-table-field">
                </td>
                <td class="num col-wh-num-50">
                  <input
                    v-model.number="draft.withhold3"
                    type="number"
                    step="0.01"
                    min="0"
                    class="income-table-field"
                    @input="onWithhold3Input"
                  >
                </td>
                <td class="num col-wh-num-50">
                  <input
                    v-model.number="draft.withhold30"
                    type="number"
                    step="0.01"
                    min="0"
                    class="income-table-field"
                    @input="onWithhold30Input"
                  >
                </td>
                <!-- <td class="font-black text-[#0d4169] text-center bg-slate-50/30 num col-wh-num-50">{{ fmt(draftTotalSales) }}</td> -->
                <td class="col-wh-text col-wh-text-field">
                  <input v-model.trim="draft.fsNo" type="text" class="wh-text-cell" autocomplete="off">
                </td>
                <td class="col-wh-image">
                  <label
                    for="wh-received-image-upload"
                    class="wh-image-upload-box"
                    :class="{ 'wh-image-upload-box--active': uploadingImage }"
                    :title="draft.imgUrl ? 'Click to change image' : 'Upload image'"
                  >
                    <img
                      v-if="draft.imgUrl && !uploadingImage"
                      :src="resolveCompanyLogoUrl(draft.imgUrl)"
                      alt="Receipt"
                      class="wh-image-preview"
                    >
                    <span v-else-if="uploadingImage" class="wh-image-placeholder">
                      <svg class="w-4 h-4 animate-spin text-[#0d4169]" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                        <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4"></circle>
                        <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4zm2 5.291A7.962 7.962 0 014 12H0c0 3.042 1.135 5.824 3 7.938l3-2.647z"></path>
                      </svg>
                    </span>
                    <span v-else class="wh-image-placeholder">
                      <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z" />
                      </svg>
                    </span>
                    <input id="wh-received-image-upload" type="file" class="hidden" accept="image/*" @change="handleImageUpload">
                  </label>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="flex justify-center pt-2 pb-0.5">
          <button
            v-if="editingId"
            type="submit"
            :disabled="!canEditWithholdingReceived || isSaving"
            class="min-w-max px-4 py-1 bg-[#0d4169] text-white text-[0.8125rem] font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:scale-95 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            <div
              v-if="isSaving"
              class="h-4 w-4 border-2 border-white/30 border-t-transparent rounded-full animate-spin"
            ></div>
            <span v-if="!isSaving">Update Changes</span>
          </button>
          <button
            v-else
            type="submit"
            :disabled="!canAddWithholdingReceived || isSaving"
            class="min-w-max px-4 py-1 bg-[#0d4169] text-white text-[0.8125rem] font-bold rounded-md shadow-md hover:bg-[#0a3354] transition-all active:scale-95 whitespace-nowrap disabled:opacity-50 disabled:cursor-not-allowed flex items-center justify-center gap-2"
          >
            <div
              v-if="isSaving"
              class="h-4 w-4 border-2 border-white/30 border-t-transparent rounded-full animate-spin"
            ></div>
            <span v-if="!isSaving">Save</span>
          </button>
        </div>
      </div>
    </form>

    <div class="px-6 pb-12 pt-8 border-t border-slate-100 bg-slate-50/30">
      <div class="flex items-center gap-6">
        <div class="flex items-center gap-3 min-w-[220px]">
          <label class="text-[0.78rem] font-semibold text-[#1e293b] shrink-0">
            Start Date <span class="text-red-500">*</span>
          </label>
          <input
            v-model="filterStart"
            type="date"
            class="flex-1 min-w-[9rem] px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer"
            required
          >
        </div>
        <div class="flex items-center gap-3 min-w-[220px]">
          <label class="text-[0.78rem] font-semibold text-[#1e293b] shrink-0">End Date</label>
          <input
            v-model="filterEnd"
            type="date"
            class="flex-1 min-w-[9rem] px-2.5 py-1.5 border border-[#cbd5e1] rounded-md outline-none focus:border-[#0d4169] transition-all text-sm bg-white cursor-pointer"
          >
        </div>
      </div>

      <div class="w-full overflow-auto custom-scrollbar wh-table-scroll-wrap pb-1">
        <table class="wh-received-table wh-received-list wh-received-list-auto consumption-table-shell w-full min-w-max bg-white rounded-xl shadow-sm">
          <!-- <caption class="caption-top text-center pb-1 text-[0.75rem] font-semibold text-[#1e293b]">
            Recorded for selected calendar date
          </caption> -->
          <thead>
            <tr>
              <th class="col-sn">S/N</th>
              <th class="col-wh-expand">Company</th>
              <th class="num col-wh-num-50">Received</th>
              <th class="num col-wh-num-50">Withhold 3%</th>
              <th class="num col-wh-num-50">Withhold 30%</th>
              <!-- <th class="num col-wh-num-50 bg-slate-50 font-semibold text-[#0d4169]">Total Sales</th> -->
              <th class="col-wh-image text-center">Image</th>
              <th class="col-wh-action col-wh-action-th">Action</th>
            </tr>
          </thead>
          <tbody>
            <tr
              v-for="(row, idx) in entriesForDate"
              :key="row.id"
              class="hover:bg-slate-50 transition-colors border-b"
            >
              <td class="col-sn">{{ idx + 1 }}</td>
              <td class="col-wh-expand">{{ row.companyName || '—' }}</td>
              <td class="num col-wh-num-50">{{ fmt(row.receivedAmount) }}</td>
              <td class="num col-wh-num-50">{{ fmt(row.withhold3) }}</td>
              <td class="num col-wh-num-50">{{ fmt(row.withhold30) }}</td>
              <!-- <td class="num col-wh-num-50 bg-slate-50 font-semibold text-[#0d4169]">{{ fmt(row.totalSales) }}</td> -->
              <td class="col-wh-image">
                <img
                  v-if="row.imgUrl"
                  :src="resolveCompanyLogoUrl(row.imgUrl)"
                  alt="Receipt"
                  class="wh-list-image wh-list-image--clickable"
                  role="button"
                  tabindex="0"
                  title="View full image"
                  @click="openImagePreview(row.imgUrl)"
                  @keydown.enter="openImagePreview(row.imgUrl)"
                >
                <span v-else class="text-slate-300">—</span>
              </td>
              <td class="col-wh-action actions">
                <button
                  type="button"
                  :disabled="!canEditWithholdingReceived"
                  @click="startEdit(row)"
                >
                  Edit
                </button>
                <button type="button" class="actions-detail">Detail</button>
              </td>
            </tr>
            <tr v-if="isLoadingList">
              <td colspan="8" class="py-12 text-center text-slate-400 italic">Loading entries…</td>
            </tr>
            <tr v-else-if="entriesForDate.length === 0">
              <td colspan="8" class="py-12 text-center text-slate-400 italic">
                {{ filterStart ? 'No recorded entries found for the selected date range.' : 'Please select a Start Date to view entries.' }}
              </td>
            </tr>
          </tbody>
          <tfoot v-if="entriesForDate.length > 0">
            <tr class="footer-total font-semibold bg-slate-100/80 border-t border-slate-200">
              <td colspan="2">Total</td>
              <td class="num col-wh-num-50">{{ fmt(sumEntries('receivedAmount')) }}</td>
              <td class="num col-wh-num-50">{{ fmt(sumEntries('withhold3')) }}</td>
              <td class="num col-wh-num-50">{{ fmt(sumEntries('withhold30')) }}</td>
              <!-- <td class="num col-wh-num-50 text-[#0d4169]">{{ fmt(sumEntries('totalSales')) }}</td> -->
              <td></td>
              <td></td>
            </tr>
          </tfoot>
        </table>
      </div>
    </div>

    <FinanceToast :show="toast.show" :variant="toast.variant">{{ toast.message }}</FinanceToast>

    <div
      v-if="imagePreviewUrl"
      class="fixed inset-0 z-[200] flex items-center justify-center px-4 py-8 bg-black/70 backdrop-blur-sm"
      @click.self="closeImagePreview"
    >
      <div class="relative max-w-[90vw] max-h-[90vh]">
        <button
          type="button"
          class="absolute -top-3 -right-3 z-10 flex h-8 w-8 items-center justify-center rounded-full bg-white text-slate-700 shadow-lg hover:bg-slate-100 transition-colors"
          aria-label="Close image preview"
          @click="closeImagePreview"
        >
          <svg class="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
          </svg>
        </button>
        <img
          :src="imagePreviewUrl"
          alt="Receipt preview"
          class="max-w-full max-h-[85vh] object-contain rounded-lg shadow-2xl bg-white"
        >
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed, onMounted, onUnmounted, reactive, ref, watch } from 'vue'
import { useStore } from 'vuex'
import FinanceToast from '../FinanceToast.vue'
import { apiFetch, normalizeUploadValue, resolveCompanyLogoUrl } from '../../../utils/api'

const store = useStore()

const currentUser = computed(() => store.getters.currentUser || store.state.user || {})

const userPrivileges = computed(() => {
  const raw = currentUser.value?.privilege
  if (!raw) return {}
  if (typeof raw === 'string') {
    try {
      return JSON.parse(raw)
    } catch {
      return {}
    }
  }
  return raw
})

const hasAllPrivilege = computed(() => {
  return userPrivileges.value?.All === true || userPrivileges.value?.all === true
})

function getPrivilegeEntry(key) {
  const priv = userPrivileges.value || {}
  if (!key) return null
  if (priv?.[key]) return priv[key]

  const normalizedNeedle = String(key).trim().toLowerCase()
  const foundKey = Object.keys(priv).find((k) => String(k).trim().toLowerCase() === normalizedNeedle)
  return foundKey ? priv[foundKey] : null
}

function getActionFlag(entry, action) {
  if (!entry || typeof entry !== 'object') return false
  if (!action) return false
  if (entry[action] !== undefined) return !!entry[action]

  const a = String(action)
  const candidates = [
    a.toLowerCase(),
    a.toUpperCase(),
    a.charAt(0).toUpperCase() + a.slice(1).toLowerCase()
  ]
  for (const k of candidates) {
    if (entry[k] !== undefined) return !!entry[k]
  }
  return false
}

const canAddWithholdingReceived = computed(() => {
  if (hasAllPrivilege.value) return true
  return getActionFlag(getPrivilegeEntry('Withholding Received'), 'Add')
})

const canEditWithholdingReceived = computed(() => {
  if (hasAllPrivilege.value) return true
  return getActionFlag(getPrivilegeEntry('Withholding Received'), 'Edit')
})

const resolvedCompanyName = computed(() => {
  const user = currentUser.value
  return (
    user?.company?.name ||
    user?.companyName ||
    user?.company_name ||
    user?.company?.company_name ||
    'Company Name'
  )
})

function todayISO() {
  const d = new Date()
  const y = d.getFullYear()
  const m = String(d.getMonth() + 1).padStart(2, '0')
  const day = String(d.getDate()).padStart(2, '0')
  return `${y}-${m}-${day}`
}

const calendarDate = ref('')
const filterStart = ref(todayISO())
const filterEnd = ref('')
const editingId = ref(null)
const isSaving = ref(false)
const isLoadingList = ref(false)
const uploadingImage = ref(false)
const entriesForDate = ref([])
const imagePreviewUrl = ref('')

const draft = reactive({
  invoiceNo: '',
  companyName: '',
  tinNo: '',
  reason: '',
  receivedAmount: 0,
  withhold3: 0,
  withhold30: 0,
  fsNo: '',
  imgUrl: ''
})

const toast = reactive({ show: false, message: '', variant: 'success' })

const displayInvoiceDate = computed(() => formatDisplayDate(calendarDate.value))

function formatDisplayDate(iso) {
  if (!iso || typeof iso !== 'string') return '—'
  const parts = iso.split('-')
  if (parts.length !== 3) return iso
  const [y, m, d] = parts
  return `${d}/${m}/${y}`
}

function n(v) {
  const x = Number(v)
  return Number.isFinite(x) ? x : 0
}

function fmt(x) {
  return n(x).toFixed(2)
}

function onWithhold3Input() {
  if (n(draft.withhold3) !== 0) {
    draft.withhold30 = 0
  }
}

function onWithhold30Input() {
  if (n(draft.withhold30) !== 0) {
    draft.withhold3 = 0
  }
}

function openImagePreview(imgUrl) {
  const url = resolveCompanyLogoUrl(imgUrl)
  if (!url) return
  imagePreviewUrl.value = url
}

function closeImagePreview() {
  imagePreviewUrl.value = ''
}

function onImagePreviewKeydown(event) {
  if (event.key === 'Escape' && imagePreviewUrl.value) {
    closeImagePreview()
  }
}

// const draftTotalSales = computed(() => n(draft.receivedAmount) + n(draft.withhold3) + n(draft.withhold30))

async function loadEntries() {
  if (!filterStart.value) {
    entriesForDate.value = []
    return
  }
  const end = filterEnd.value || filterStart.value
  isLoadingList.value = true
  try {
    const params = new URLSearchParams({
      startDate: filterStart.value,
      endDate: end
    })
    const res = await apiFetch(`/finance/withholding-received?${params}`)
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      showToast(err.message || 'Failed to load entries.', 5000, 'error')
      entriesForDate.value = []
      return
    }
    const data = await res.json().catch(() => [])
    entriesForDate.value = Array.isArray(data) ? data : []
  } catch {
    showToast('Failed to load entries.', 5000, 'error')
    entriesForDate.value = []
  } finally {
    isLoadingList.value = false
  }
}

function sumEntries(key) {
  return entriesForDate.value.reduce((a, r) => a + n(r[key]), 0)
}

let toastTimer = null
function showToast(message, durationMs = 1600, variant = 'success') {
  if (toastTimer) {
    clearTimeout(toastTimer)
    toastTimer = null
  }
  toast.message = message
  toast.variant = variant
  toast.show = true
  toastTimer = window.setTimeout(() => {
    toast.show = false
    toastTimer = null
  }, durationMs)
}

function resetDraft() {
  editingId.value = null
  draft.invoiceNo = ''
  draft.companyName = ''
  draft.tinNo = ''
  draft.reason = ''
  draft.receivedAmount = 0
  draft.withhold3 = 0
  draft.withhold30 = 0
  draft.fsNo = ''
  draft.imgUrl = ''
}

async function handleImageUpload(event) {
  const file = event.target.files[0]
  if (!file) return

  if (file.size > 3 * 1024 * 1024) {
    showToast('File is too large. Max 3MB.', 3000, 'error')
    event.target.value = ''
    return
  }

  uploadingImage.value = true
  try {
    const formData = new FormData()
    formData.append('logo', file)

    const res = await apiFetch('/upload', {
      method: 'POST',
      body: formData
    })

    if (res.ok) {
      const data = await res.json()
      draft.imgUrl = normalizeUploadValue(data.url)
    } else {
      showToast('Failed to upload image.', 3000, 'error')
    }
  } catch {
    showToast('Failed to upload image.', 3000, 'error')
  } finally {
    uploadingImage.value = false
    event.target.value = ''
  }
}

async function onCalendarChange() {
  resetDraft()
  filterStart.value = calendarDate.value
  filterEnd.value = ''
}

function startEdit(row) {
  if (!canEditWithholdingReceived.value) return
  editingId.value = row.id
  draft.invoiceNo = row.invoiceNo || ''
  draft.companyName = row.companyName || ''
  draft.tinNo = row.tinNo || ''
  draft.reason = row.reason || ''
  draft.receivedAmount = n(row.receivedAmount)
  draft.withhold3 = n(row.withhold3)
  draft.withhold30 = n(row.withhold30)
  if (n(draft.withhold3) !== 0 && n(draft.withhold30) !== 0) {
    draft.withhold30 = 0
  }
  draft.fsNo = row.fsNo || ''
  draft.imgUrl = normalizeUploadValue(row.imgUrl)
}

async function saveEntry() {
  if (isSaving.value) return
  if (editingId.value != null) {
    if (!canEditWithholdingReceived.value) return
  } else if (!canAddWithholdingReceived.value) {
    return
  }
  const companyName = String(draft.companyName || '').trim()
  const invoiceNo = String(draft.invoiceNo || '').trim()
  if (!companyName && !invoiceNo) {
    showToast('Enter company name or invoice number.', 1600, 'error')
    return
  }

  const body = {
    invoiceDate: calendarDate.value,
    invoiceNo,
    companyName,
    tinNo: String(draft.tinNo || '').trim(),
    reason: String(draft.reason || '').trim(),
    receivedAmount: n(draft.receivedAmount),
    withhold3: n(draft.withhold3),
    withhold30: n(draft.withhold30),
    fsNo: String(draft.fsNo || '').trim(),
    imgUrl: normalizeUploadValue(draft.imgUrl) || null
  }

  isSaving.value = true
  try {
    if (editingId.value != null) {
      const res = await apiFetch(`/finance/withholding-received/${editingId.value}`, {
        method: 'PUT',
        body: JSON.stringify(body)
      })
      if (!res.ok) {
        const err = await res.json().catch(() => ({}))
        showToast(err.message || 'Failed to update entry.', 5000, 'error')
        return
      }
      showToast('Entry updated successfully.')
      resetDraft()
      await loadEntries()
      return
    }

    const res = await apiFetch('/finance/withholding-received', {
      method: 'POST',
      body: JSON.stringify(body)
    })
    if (!res.ok) {
      const err = await res.json().catch(() => ({}))
      showToast(err.message || 'Failed to save entry.', 5000, 'error')
      return
    }
    showToast('Entry saved successfully.')
    resetDraft()
    await loadEntries()
  } catch {
    showToast('Failed to save entry.', 5000, 'error')
  } finally {
    isSaving.value = false
  }
}

// function handleImport() {
//   showToast('Import will be available soon.')
// }

// function downloadSampleUiOnly() {
//   showToast('Sample form download will be available soon.')
// }

watch([filterStart, filterEnd], () => {
  loadEntries()
})

onMounted(() => {
  loadEntries()
  window.addEventListener('keydown', onImagePreviewKeydown)
})

onUnmounted(() => {
  window.removeEventListener('keydown', onImagePreviewKeydown)
})
</script>

<style scoped>
/*
 * Columns + fields: incomePage.vue-style numeric widths (fixed ≥ lg via .wh-received-entry / list).
 * Scroll surface + scrollbar visuals: production/consumption/consumptionPage.vue (overflow-auto + custom-scrollbar + min-w-max).
 */
.wh-received-table {
  font-family: 'Segoe UI', sans-serif;
  font-size: 0.75rem;
  color: #1e293b;
}

/* Same border model as `.consumption-table` */
.consumption-table-shell {
  border-collapse: collapse;
}

/* Space above horizontal scrollbar + table content */
.wh-table-scroll-wrap {
  padding-top: 20px;
  box-sizing: border-box;
}

.wh-received-table caption {
  caption-side: top;
  text-align: center;
}

.wh-received-table caption.caption-wh-entry {
  text-align: left;
}

.wh-received-table th,
.wh-received-table td {
  padding: 3px 6px;
  text-align: center;
  border-bottom: 1px solid #e2e8f0;
  vertical-align: middle;
  font-size: 0.72rem;
  line-height: 1.2;
}

.wh-received-table thead th {
  cursor: default;
}

.wh-received-table th {
  background: #f1f5f9;
  font-weight: 600;
  position: sticky;
  top: 0;
  z-index: 20;
}

.wh-received-table th.num,
.wh-received-table td.num {
  text-align: center;
  white-space: nowrap;
}

/* Entry table: uniform narrower columns + standard (non-compact) density */
.wh-received-table.wh-received-entry {
  --wh-field-col: 5.5rem;
  --wh-image-col: 3.5rem;
  table-layout: fixed;
  width: calc(10 * var(--wh-field-col) + var(--wh-image-col));
  min-width: calc(10 * var(--wh-field-col) + var(--wh-image-col));
}

.wh-received-entry thead th,
.wh-received-entry tbody td {
  width: var(--wh-field-col);
  min-width: var(--wh-field-col);
  max-width: var(--wh-field-col);
  box-sizing: border-box;
}

.wh-received-entry thead th {
  white-space: normal;
  overflow-wrap: break-word;
  hyphens: auto;
}

.wh-received-table th.col-wh-num-50 {
  white-space: normal;
}

.wh-received-entry input.wh-text-cell,
.wh-received-entry input.income-table-field {
  width: 100%;
  min-width: 0;
  max-width: 100%;
  box-sizing: border-box;
}

.wh-received-entry thead th.col-wh-image,
.wh-received-entry tbody td.col-wh-image {
  width: var(--wh-image-col);
  min-width: var(--wh-image-col);
  max-width: var(--wh-image-col);
}

.wh-received-entry td.num input.income-table-field {
  display: block;
}

/* List table: columns size to header / cell content (no fixed amount-column width) */
.wh-received-table.wh-received-list.wh-received-list-auto {
  table-layout: auto;
  width: auto;
  min-width: 100%;
}

.wh-received-list-auto th,
.wh-received-list-auto td {
  width: auto;
  min-width: max(2.25rem, min-content);
  max-width: none;
  box-sizing: border-box;
}

.wh-received-list-auto thead th {
  white-space: nowrap;
}

.wh-received-list-auto .col-wh-expand {
  min-width: max(6rem, max-content);
  white-space: normal;
  word-break: normal;
  overflow-wrap: break-word;
  text-align: left;
}

.wh-received-table input.income-table-field {
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  padding: 2px 4px;
  border: 1px solid transparent;
  border-radius: 0.1875rem;
  outline: none;
  background-color: rgb(254 242 242);
  font-size: 0.72rem;
  line-height: 1.1rem;
  text-align: center;
  font-variant-numeric: tabular-nums;
  transition:
    border-color 0.15s,
    background-color 0.15s;
}

.wh-received-table input.income-table-field:hover {
  border-color: #cbd5e1;
}

.wh-received-table input.income-table-field:focus {
  border-color: #0d4169;
  background-color: #fff;
}

.wh-received-table input[type='number']::-webkit-inner-spin-button,
.wh-received-table input[type='number']::-webkit-outer-spin-button {
  -webkit-appearance: none;
  margin: 0;
}

.wh-received-table input[type='number'] {
  -moz-appearance: textfield;
  appearance: textfield;
}

.wh-received-table input.wh-text-cell {
  box-sizing: border-box;
  min-width: 0;
  width: 100%;
  padding: 2px 4px;
  border: 1px solid transparent;
  border-radius: 0.1875rem;
  outline: none;
  background-color: rgb(254 242 242);
  font-size: 0.72rem;
  line-height: 1.1rem;
  text-align: center;
  transition:
    border-color 0.15s,
    background-color 0.15s;
}

.wh-received-table input.wh-text-cell:hover {
  border-color: #cbd5e1;
}

.wh-received-table input.wh-text-cell:focus {
  border-color: #0d4169;
  background-color: #fff;
}

.wh-received-list tbody tr:hover {
  background: #f1f5f9;
}

.cell-readonly {
  background: #f8fafc;
  color: #475569;
  font-weight: 600;
  white-space: nowrap;
}

@media (min-width: 1024px) {
  table.wh-received-list.wh-received-list-auto {
    table-layout: auto;
    width: auto;
    min-width: 100%;
  }

  table.wh-received-list.wh-received-list-auto .col-sn {
    width: auto;
    min-width: max(2rem, max-content);
    text-align: center;
    white-space: nowrap;
  }

  table.wh-received-list.wh-received-list-auto thead th.col-wh-expand {
    white-space: nowrap;
  }

  table.wh-received-list.wh-received-list-auto .col-wh-expand {
    width: auto;
    min-width: max(8rem, max-content);
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    text-align: left;
  }

  table.wh-received-list.wh-received-list-auto tbody td.col-wh-expand {
    word-break: normal;
    overflow-wrap: break-word;
  }

  table.wh-received-list.wh-received-list-auto .col-wh-action {
    width: auto;
    min-width: max(5.25rem, max-content);
    max-width: none;
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
  }

  table.wh-received-list.wh-received-list-auto th.col-wh-action-th {
    text-align: center;
    white-space: nowrap;
    vertical-align: middle;
  }
}

@media (max-width: 1023.98px) {
  table.wh-received-entry .col-wh-date,
  table.wh-received-list .col-sn {
    white-space: nowrap;
  }

  table.wh-received-list .col-sn {
    text-align: center;
    white-space: nowrap;
    min-width: 2rem;
  }

  table.wh-received-entry .col-wh-expand,
  table.wh-received-list.wh-received-list-auto .col-wh-expand {
    white-space: normal;
    word-break: normal;
    overflow-wrap: break-word;
    min-width: 9rem;
  }

  table.wh-received-entry thead th.col-wh-expand,
  table.wh-received-list.wh-received-list-auto thead th.col-wh-expand {
    white-space: nowrap;
  }

  table.wh-received-list.wh-received-list-auto thead th.col-wh-expand,
  table.wh-received-list.wh-received-list-auto tbody td.col-wh-expand {
    text-align: left;
  }

  table.wh-received-entry th.num,
  table.wh-received-entry td.num,
  table.wh-received-list th.num,
  table.wh-received-list td.num {
    white-space: nowrap;
  }

  table.wh-received-list .col-wh-action,
  table.wh-received-list td.actions {
    text-align: center;
    vertical-align: middle;
    white-space: nowrap;
  }

  .wh-received-table input.income-table-field {
    max-width: 100%;
    display: block;
  }
}

.actions {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;
}

.actions button {
  background: none;
  border: none;
  color: #2563eb;
  cursor: pointer;
  text-decoration: underline;
  font-size: 0.78rem;
  padding: 0;
  display: flex;
  align-items: center;
}

.actions button:disabled {
  color: #94a3b8;
  cursor: not-allowed;
  text-decoration: none;
}

.actions button.actions-detail {
  color: #0d4169;
  text-decoration: none;
  font-weight: 700;
}

.actions button.actions-detail:hover {
  color: #0a3354;
  text-decoration: underline;
}

.footer-total td {
  font-size: 0.72rem;
  padding-top: 4px;
  padding-bottom: 4px;
}

.col-wh-image {
  width: 3.5rem;
  min-width: 3.5rem;
  max-width: 3.5rem;
  text-align: center;
  vertical-align: middle;
}

.wh-image-upload-box {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 2.75rem;
  height: 2.25rem;
  margin: 0 auto;
  border: 1px dashed #cbd5e1;
  border-radius: 0.25rem;
  background: #fff;
  cursor: pointer;
  overflow: hidden;
  transition: border-color 0.15s, background-color 0.15s;
}

.wh-image-upload-box:hover,
.wh-image-upload-box--active {
  border-color: #0d4169;
  background: #f8fafc;
}

.wh-image-preview {
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
}

.wh-image-placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
}

.wh-list-image {
  width: 2.5rem;
  height: 2rem;
  object-fit: cover;
  border-radius: 0.25rem;
  border: 1px solid #e2e8f0;
  display: block;
  margin: 0 auto;
}

.wh-list-image--clickable {
  cursor: pointer;
  transition: border-color 0.15s, box-shadow 0.15s;
}

.wh-list-image--clickable:hover {
  border-color: #0d4169;
  box-shadow: 0 0 0 2px rgba(13, 65, 105, 0.15);
}

/* consumptionPage.vue — horizontal/vertical scrollbar styling */
.custom-scrollbar::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: #f1f5f9;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 4px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: #94a3b8;
}
</style>
